const modalComponent = () => {

    function bindModal(triggerSelector, modalSelector, closeSelector, displayType = 'block') {
        const trigger = triggerSelector ? document.querySelectorAll( triggerSelector ) : 0,
              modal = document.querySelector( modalSelector ),
              close = modal.querySelectorAll( closeSelector );

        if ( trigger ) {
            trigger.forEach( item => {
                item.addEventListener('click', ( e ) => {
                    e.preventDefault();

                    if ( e.target === item ) {
                        modal.style.display = displayType;
                        document.body.classList.add('no-scroll');
                    }
                });
            });
        }


        close.forEach( closeBtn => {
            closeBtn.addEventListener('click', () => {

                modal.style.display = "none";
                document.body.classList.remove('no-scroll');

            } );
        } );


        modal.addEventListener('click', (e) => {

            if ( e.target === modal ) {
                modal.style.display = "none";
                document.body.classList.remove('no-scroll');
            }
        });

    }

    bindModal('button[data-href$="?compatibility-request"]', '#compatibility-request', '.close-popup', 'flex');
    bindModal('button[data-href$="?ask-question"]', '#ask-question', '.close-popup' );
    bindModal('', '.form__thanks[style*="display: none"]', '.close-popup');
}
export default modalComponent;